import {Col, Row} from "reactstrap";
import {BizKeys, LoginLines} from "../../../../core/constants/enums";
import {Fade} from "@material-ui/core";
import React from "react";
import classnames from "classnames";
import {ReactComponent as InfiniteKey} from "../../../../assets/images/login-page/infinite_key.svg";
import {ReactComponent as ActKey} from "../../../../assets/images/login-page/act_key.svg";
import {ReactComponent as AimKey} from "../../../../assets/images/login-page/aim_key.svg";
import {logoWidth, maxHeight, minHeight} from "../index";

const BizKeySection = ({selectedKey, onKeyClicked, jsonContent}) => {

    return (
        <>
            <div className={'h-100'}
                 style={{
                     minHeight: minHeight,
                     maxHeight: maxHeight,
                 }}
            >
                <Row className={'h-100'}>
                    {/** The Vertical Line at left */}
                    <Col className={'h-100 d-flex align-items-center flex-grow-0'}>
                        <div id={LoginLines.leftVertical}
                             className={classnames(
                                 'line-vertical',
                                 'arrow-up',
                                 'transition',
                                 'h-75',
                             )}
                        />
                    </Col>
                    <Col className={'h-100'}>
                        <Row className={'h-100'}>
                            <Col xs={12}>
                                <Row>
                                    {/** The Horizontal Line at top */}
                                    <Col
                                        className={'d-flex flex-column justify-content-center align-items-center'}>
                                        <div id={LoginLines.topHorizontal}
                                             className={classnames(
                                                 'line-horizontal',
                                                 'arrow-right',
                                                 'transition',
                                                 'w-100',
                                             )}
                                        />
                                        <MessageContainer
                                            selectedKey={selectedKey}
                                            bizkey={BizKeys.aimKey}
                                            jsonContent={jsonContent.bizkey?.aimKey}
                                        />
                                    </Col>
                                    {/** AimKey */}
                                    <Col className={'flex-grow-0'}>
                                        <AimKey
                                            style={{width: `${logoWidth}px`}}
                                            className={'transition cursor-pointer-hover'}
                                            onClick={() => onKeyClicked(BizKeys.aimKey)}
                                            {...(selectedKey !== BizKeys.aimKey ? {opacity: '0.3'} : {})}
                                        />
                                        <BizPhaseName
                                            bizkey={BizKeys.aimKey}
                                            selectedKey={selectedKey}
                                            onClick={() => onKeyClicked(BizKeys.aimKey)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className={'d-flex flex-column justify-content-center align-items-end h-50'}>
                                <Row className={'h-100'}>
                                    {/** Right Top vertical Line */}
                                    <Col xs={12} className={'d-flex justify-content-center'}>
                                        <div id={LoginLines.topRightVertical}
                                             className={classnames(
                                                 'line-vertical',
                                                 'arrow-down',
                                                 'transition',
                                                 'h-100',
                                             )}
                                        />
                                    </Col>
                                    {/** ActKey */}
                                    <Col xs={12} className={'d-flex justify-content-end align-items-center'}>
                                        <ActKey
                                            {...(selectedKey !== BizKeys.actKey ? {opacity: '0.3'} : {})}
                                            className={'transition cursor-pointer-hover'}
                                            onClick={() => onKeyClicked(BizKeys.actKey)}
                                            style={{width: `${logoWidth}px`}}
                                        />
                                        <BizPhaseName
                                            bizkey={BizKeys.actKey}
                                            selectedKey={selectedKey}
                                            onClick={() => onKeyClicked(BizKeys.actKey)}
                                        />
                                    </Col>
                                    {/** Right Bottom vertical Line */}
                                    <Col xs={12} className={'d-flex justify-content-center'}>
                                        <div id={LoginLines.bottomRightVertical}
                                             className={classnames(
                                                 'line-vertical',
                                                 'arrow-down',
                                                 'transition',
                                                 'h-100',
                                             )}
                                        />
                                    </Col>
                                </Row>
                                <MessageContainer
                                    selectedKey={selectedKey}
                                    bizkey={BizKeys.actKey}
                                    jsonContent={jsonContent.bizkey?.actKey}
                                />
                            </Col>
                            <Col xs={12}>
                                <Row>
                                    {/** The Horizontal Line at Bottom */}
                                    <Col
                                        className={'d-flex flex-column justify-content-center align-items-center'}
                                    >
                                        <div id={LoginLines.bottomHorizontal}
                                             className={classnames(
                                                 'line-horizontal',
                                                 'arrow-left',
                                                 'transition',
                                                 'w-100',
                                             )}
                                        />
                                        <MessageContainer
                                            selectedKey={selectedKey}
                                            bizkey={BizKeys.infiniteKey}
                                            jsonContent={jsonContent.bizkey?.infiniteKey}
                                        />
                                    </Col>
                                    {/** InfiniteKey */}
                                    <Col className={'flex-grow-0'}>
                                        <InfiniteKey
                                            {...(selectedKey !== BizKeys.infiniteKey ? {opacity: '0.3'} : {})}
                                            className={'transition cursor-pointer-hover'}
                                            onClick={() => onKeyClicked(BizKeys.infiniteKey)}
                                            style={{width: `${logoWidth}px`}}
                                        />
                                        <BizPhaseName
                                            bizkey={BizKeys.infiniteKey}
                                            selectedKey={selectedKey}
                                            onClick={() => onKeyClicked(BizKeys.infiniteKey)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </>
    );
}

const MessageContainer = ({bizkey, selectedKey, jsonContent}) => {

    if (bizkey === BizKeys.actKey) {
        return (
            <Row style={{marginRight: '13rem', left: 0, right: 0}} className={'w-75 h-100' +
                ' justify-content-center' +
                ' align-items-center' +
                ' position-absolute'}>
                <Fade in={selectedKey === bizkey} mountOnEnter unmountOnExit>
                    <div className={'p-2 bg-white position-absolute m-auto transition w-50'}>
                        <div className={'p-3 rounded-xxl transition'} style={{backgroundColor: selectedKey.focusColor}}>
                            <h1 className={'text-title white font-weight-medium mb-3'}>
                                {jsonContent.title}
                            </h1>
                            <p className={'text-sm white soft-wrap font-weight-medium text-wrap'}>
                                {jsonContent.message}
                            </p>
                        </div>
                    </div>
                </Fade>
            </Row>
        );
    }

    return (
        <Fade in={selectedKey === bizkey} mountOnEnter unmountOnExit>
            <div className={'p-2 bg-white z-index-100 position-absolute m-auto transition w-50'}>
                <div className={'p-3 rounded-xxl transition'} style={{backgroundColor: selectedKey.focusColor}}>
                    <h1 className={'text-title white font-weight-medium mb-3'}>
                        {jsonContent.title}
                    </h1>
                    <p className={'text-sm white soft-wrap font-weight-medium text-wrap'}>
                        {jsonContent.message}
                    </p>
                </div>
            </div>
        </Fade>


    );
}

const BizPhaseName = ({bizkey, selectedKey, onClick}) => {
    let top, left, color, padding;
    const focus = selectedKey === bizkey;
    switch (bizkey) {
        case BizKeys.aimKey:
            top = 86;
            left = 112;
            color = focus ? 'bg-orange' : 'bg-orange-light';
            padding = 'px-4-5';
            break;
        case BizKeys.actKey:
            top = 128;
            left = 176;
            color = focus ? 'bg-green' : 'bg-green-light';
            padding = 'px-4-5';
            break;
        case BizKeys.infiniteKey:
            color = focus ? 'bg-blue' : 'bg-blue-light';
            top = 89.1;
            left = 112;
            padding = 'px-3-1';
            break;
    }

    return (
        <div className={classnames('position-absolute py-0 bg-white cursor-pointer-hover')}
             onClick={onClick}
             style={{top: top, left: left}}>
            <div className={classnames(color, padding, 'transition')}>
                <p>
                    <span className={'black font-weight-bold text-xs '}>{bizkey.name}</span>
                    <span className={'white font-weight-bold text-xs'}>KEY</span>
                </p>
            </div>
        </div>

    );
}


export default BizKeySection;
